'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'itinerary_status',
    viewClass: require('./view'),

    methods: {
        setMmbLink(mmbLink) {
            this.setMmbLink(mmbLink);
        },
        getAirlineList(callback) {
            callback(this.getAirlineList());
        },
    },
});
